/* Collection Drag Grid JS — Paul Hamilton型をJOEKR向けに移植
   無限スクロール仮想化 + 慣性 + ラテン方陣分散 + クリックで商品ページ遷移
*/
(() => {
  const TILE_WIDTH_BASE = 220;
  const TILE_ASPECT = 3 / 4;  // 縦長3:4
  const GAP_X = 80;
  const GAP_Y = 80;
  const STAGGER = 0.5;
  const FRICTION = 0.94;
  const VELOCITY_STOP = 0.05;
  const VELOCITY_SAMPLE_MS = 80;
  const VELOCITY_CAP = 4.0;
  const CLICK_DIST = 6;
  const CLICK_TIME = 350;
  const ENTRANCE_STEP_MS = 70;
  const ENTRANCE_TRANSITION_MS = 800;

  const section = document.querySelector('.jhdrag');
  if (!section) return;
  const hero = section.querySelector('.jhdrag__hero');
  const grid = section.querySelector('.jhdrag__grid');
  const dataEl = section.querySelector('#jhdragData');
  if (!hero || !grid || !dataEl) return;

  let PRODUCTS = [];
  try { PRODUCTS = JSON.parse(dataEl.textContent) || []; } catch (_) { return; }
  if (!PRODUCTS.length) return;

  const N = PRODUCTS.length;
  // 隣接重複なしの分散係数を選ぶ
  // (c + K*r) mod N で隣接(1,0)(0,1)(1,1)(1,-1)が全て非0 mod N → Kは「Nと互いに素」かつ K, K±1 も N の倍数でない
  function pickK() {
    for (let k = Math.max(2, Math.floor(Math.sqrt(N))); k < N; k++) {
      if (gcd(k, N) !== 1) continue;
      if ((k % N) === 0 || ((k + 1) % N) === 0 || ((k - 1) % N) === 0) continue;
      return k;
    }
    return 1;
  }
  function gcd(a, b) { while (b) { [a, b] = [b, a % b]; } return a; }
  const K = pickK();

  function indexFor(c, r) {
    return ((c + K * r) % N + N) % N;
  }
  function productFor(c, r) { return PRODUCTS[indexFor(c, r)]; }

  let tileW, tileH, colStep, rowStep;
  function computeLayout() {
    const vw = window.innerWidth;
    const base = vw < 640 ? 140 : vw < 1024 ? 170 : TILE_WIDTH_BASE;
    tileW = base;
    tileH = Math.round(base / TILE_ASPECT);
    colStep = tileW + GAP_X;
    rowStep = tileH + GAP_Y;
  }
  computeLayout();

  let ox = 0, oy = 0;
  let entranceArmed = true;
  const tilePool = [];
  const liveTiles = new Map();

  function acquireTile() {
    if (tilePool.length) return tilePool.pop();
    const el = document.createElement('div');
    el.className = 'jhdrag__tile';
    if (entranceArmed) el.classList.add('entering');
    const img = document.createElement('img');
    img.draggable = false;
    img.decoding = 'async';
    img.loading = 'eager';
    el.appendChild(img);
    const meta = document.createElement('div');
    meta.className = 'jhdrag__tile__meta';
    const title = document.createElement('p');
    title.className = 'jhdrag__tile__title';
    const price = document.createElement('p');
    price.className = 'jhdrag__tile__price';
    meta.appendChild(title);
    meta.appendChild(price);
    el.appendChild(meta);
    grid.appendChild(el);
    return { el, img, title, price, src: '', url: '' };
  }
  function releaseTile(t) {
    t.el.style.transform = 'translate3d(-99999px,-99999px,0)';
    tilePool.push(t);
  }

  function render() {
    const W = window.innerWidth;
    const H = window.innerHeight;
    const cMin = Math.floor((-ox - tileW) / colStep) - 1;
    const cMax = Math.floor((-ox + W) / colStep) + 1;
    const needed = new Set();

    for (let c = cMin; c <= cMax; c++) {
      const colX = c * colStep + ox;
      const stagger = (((c % 2) + 2) % 2) * rowStep * STAGGER;
      const rMin = Math.floor((-oy - stagger - tileH) / rowStep) - 1;
      const rMax = Math.floor((-oy - stagger + H) / rowStep) + 1;
      for (let r = rMin; r <= rMax; r++) {
        const key = c + ',' + r;
        needed.add(key);
        const rowY = r * rowStep + oy + stagger;
        let t = liveTiles.get(key);
        if (!t) {
          t = acquireTile();
          t.c = c; t.r = r;
          t.el.style.width = tileW + 'px';
          t.el.style.height = tileH + 'px';
          const p = productFor(c, r);
          if (t.src !== p.image) { t.img.src = p.image; t.src = p.image; }
          if (t.url !== p.url)   { t.url = p.url; }
          t.title.textContent = p.title;
          t.price.textContent = p.price;
          liveTiles.set(key, t);
        }
        t.el.style.transform = `translate3d(${colX}px, ${rowY}px, 0)`;
      }
    }
    for (const [key, t] of liveTiles) {
      if (!needed.has(key)) {
        liveTiles.delete(key);
        releaseTile(t);
      }
    }
  }

  // ---------- ドラッグ + 慣性 ----------
  let dragging = false, pointerId = null;
  let lastX = 0, lastY = 0;
  let samples = [];
  let vx = 0, vy = 0;
  let rafId = null, lastFrameTime = 0;

  function startInertiaLoop() {
    if (rafId != null) return;
    lastFrameTime = performance.now();
    const step = (now) => {
      const dt = Math.min(48, now - lastFrameTime);
      lastFrameTime = now;
      if (!dragging) {
        ox += vx * dt;
        oy += vy * dt;
        const decay = Math.pow(FRICTION, dt / (1000/60));
        vx *= decay;
        vy *= decay;
        if (Math.hypot(vx, vy) < VELOCITY_STOP) {
          vx = 0; vy = 0;
          render();
          rafId = null;
          return;
        }
      }
      render();
      rafId = requestAnimationFrame(step);
    };
    rafId = requestAnimationFrame(step);
  }

  function pushSample(x, y) {
    const now = performance.now();
    samples.push({ t: now, x, y });
    while (samples.length > 1 && now - samples[0].t > VELOCITY_SAMPLE_MS) samples.shift();
  }
  function estimateVelocity() {
    if (samples.length < 2) return { vx: 0, vy: 0 };
    const first = samples[0];
    const last = samples[samples.length - 1];
    const dt = last.t - first.t;
    if (dt <= 0) return { vx: 0, vy: 0 };
    let evx = (last.x - first.x) / dt;
    let evy = (last.y - first.y) / dt;
    const speed = Math.hypot(evx, evy);
    if (speed > VELOCITY_CAP) {
      const k = VELOCITY_CAP / speed;
      evx *= k; evy *= k;
    }
    return { vx: evx, vy: evy };
  }

  let downX = 0, downY = 0, downT = 0, downTile = null;

  function onPointerDown(e) {
    dragging = true;
    pointerId = e.pointerId;
    hero.setPointerCapture(pointerId);
    hero.classList.add('dragging');
    lastX = e.clientX; lastY = e.clientY;
    downX = e.clientX; downY = e.clientY; downT = performance.now();
    downTile = e.target.closest && e.target.closest('.jhdrag__tile');
    samples = [];
    pushSample(e.clientX, e.clientY);
    vx = 0; vy = 0;
    startInertiaLoop();
  }
  function onPointerMove(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    const dx = e.clientX - lastX;
    const dy = e.clientY - lastY;
    lastX = e.clientX; lastY = e.clientY;
    ox += dx; oy += dy;
    pushSample(e.clientX, e.clientY);
    if (rafId == null) render();
  }
  function onPointerUp(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    dragging = false;
    try { hero.releasePointerCapture(pointerId); } catch (_) {}
    hero.classList.remove('dragging');
    pointerId = null;
    const dx = e.clientX - downX;
    const dy = e.clientY - downY;
    const dt = performance.now() - downT;
    const wasClick = Math.hypot(dx, dy) < CLICK_DIST && dt < CLICK_TIME && downTile;
    if (wasClick) {
      vx = 0; vy = 0;
      // 該当タイルの url へ遷移
      for (const [, t] of liveTiles) {
        if (t.el === downTile && t.url) {
          window.location.href = t.url;
          break;
        }
      }
      downTile = null;
      return;
    }
    downTile = null;
    const v = estimateVelocity();
    vx = v.vx; vy = v.vy;
    startInertiaLoop();
  }
  hero.addEventListener('pointerdown', onPointerDown);
  hero.addEventListener('pointermove', onPointerMove);
  hero.addEventListener('pointerup', onPointerUp);
  hero.addEventListener('pointercancel', onPointerUp);
  hero.addEventListener('dragstart', e => e.preventDefault());

  let resizeRaf = null;
  window.addEventListener('resize', () => {
    if (resizeRaf) cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(() => {
      computeLayout();
      for (const t of liveTiles.values()) {
        t.el.style.width = tileW + 'px';
        t.el.style.height = tileH + 'px';
      }
      for (const t of tilePool) {
        t.el.style.width = tileW + 'px';
        t.el.style.height = tileH + 'px';
      }
      render();
    });
  });

  // ---------- 初回 + 波アニメ ----------
  render();
  function runEntrance() {
    let minC = Infinity, minR = Infinity;
    for (const t of liveTiles.values()) {
      if (t.c < minC) minC = t.c;
      if (t.r < minR) minR = t.r;
    }
    let maxStep = 0;
    for (const t of liveTiles.values()) {
      const step = (t.c - minC) + (t.r - minR);
      if (step > maxStep) maxStep = step;
      t.el.style.setProperty('--enter-delay', (step * ENTRANCE_STEP_MS) + 'ms');
    }
    requestAnimationFrame(() => requestAnimationFrame(() => {
      for (const t of liveTiles.values()) {
        if (t.el.classList.contains('entering')) t.el.classList.add('entered');
      }
    }));
    section.classList.add('loaded');
    setTimeout(() => {
      entranceArmed = false;
      for (const t of liveTiles.values()) {
        t.el.classList.remove('entering', 'entered');
        t.el.style.removeProperty('--enter-delay');
      }
    }, maxStep * ENTRANCE_STEP_MS + ENTRANCE_TRANSITION_MS + 200);
  }
  runEntrance();
})();
